var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"collapse-menu el-icon-s-fold",class:[_vm.collapse ? 'transform' : ''],on:{"click":_vm.handleChangeCollapse}})}
var staticRenderFns = []

export { render, staticRenderFns }